import { Skeleton } from '@/components/ui/skeleton';

/**
 * Stands in for Stripe's PaymentElement until it reports ready. The shape mirrors the card
 * form it replaces — method tabs, card number, expiry + CVC, name, country — so the panel
 * does not resize when the real fields arrive.
 */
export function FormSkeleton() {
  return (
    <div className="flex flex-col gap-4" data-testid="stripe-form-skeleton">
      <div className="grid grid-cols-2 gap-3">
        <Skeleton className="h-[62px] rounded-lg" />
        <Skeleton className="h-[62px] rounded-lg" />
      </div>

      <div className="flex flex-col gap-1.5">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-[38px] rounded-lg" />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="flex flex-col gap-1.5">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-[38px] rounded-lg" />
        </div>
        <div className="flex flex-col gap-1.5">
          <Skeleton className="h-3 w-10" />
          <Skeleton className="h-[38px] rounded-lg" />
        </div>
      </div>

      <div className="flex flex-col gap-1.5">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-[38px] rounded-lg" />
      </div>
    </div>
  );
}
